import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { animated, useSpring } from '@react-spring/web';

// import { useSpring, animated } from '@react-spring/web';
import * as AppPropTypes from '../../lib/PropTypes';

import FitText from '../partials/FitText';

import styles from '../../../styles/headers/page-header.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const PageHeader = ({ page, className }) => {
    const [animate, setAnimate] = useState(false);

    const { title = null, handle = null, theme } = page || {};
    const { colors = null } = theme || {};
    const { secondary = null } = colors || {};

    useEffect(() => {
        setAnimate(false);
        const timeout = setTimeout(() => setAnimate(true), 100);
        return () => {
            clearTimeout(timeout);
            setAnimate(false);
        };
    }, [handle]);

    const getStyle = useCallback(
        (ratio) => {
            const opacityRatio =
                (100 - Math.round((window.scrollY / window.innerHeight) * 100)) / 100;
            return {
                y: window.scrollY / ratio,
                opacity: opacityRatio,
                // color: secondary
            };
        },
        [secondary],
    );

    const [titleStyle, titleSpringApi] = useSpring(() => getStyle(4));

    useEffect(() => {
        const onScroll = () => {
            titleSpringApi.start(getStyle(4));
        };
        window.addEventListener('scroll', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [titleSpringApi]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.animate]: animate,
                    [className]: className !== null,
                },
            ])}
        >
            {title !== null ? (
                <div className={styles.inner}>
                    <animated.div className={styles.title} style={titleStyle}>
                        <FitText contentClassName={styles.titleContent}>
                            {title.split('').map((l, idx) => (
                                <span
                                    key={`letter-${idx + 1}`}
                                    className={styles.letter}
                                    style={{ animationDelay: `${idx * 75 + 200}ms` }}
                                >
                                    {l}
                                </span>
                            ))}
                        </FitText>
                    </animated.div>
                </div>
            ) : null}
        </div>
    );
};

PageHeader.propTypes = propTypes;
PageHeader.defaultProps = defaultProps;

export default PageHeader;
